import { LoginCard } from "apps/common/authentication/common/LoginCard";
import { defaultSingleManagerPoweredByMessage } from "apps/common/authentication/common/LoginCard/constants";
import { Text, TypeStyle } from "@jsq/ds/deprecated";
import { JSQ_PHONE, JSQ_SUPPORT_EMAIL } from "common/constants/copy";
import { Button } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";

import React from "react";

export type SupportCardProps = {
  arenaName?: string;
  onGoBackClick: () => void;
};

/**
 * A CTA card to explain to users how to get extended support in case they have forgotten their recovery codes.
 */
export const SupportCard: React.FC<SupportCardProps> = ({
  arenaName,
  onGoBackClick,
}: SupportCardProps) => {
  return (
    <LoginCard
      showPoweredByHeader={!!arenaName}
      poweredByHelpMessage={defaultSingleManagerPoweredByMessage(arenaName)}
      showCardTitle
      cardTitle="Contact support"
      titleDataTestId="support-card-title"
    >
      <Text
        className="align-center stacked-xl"
        as="p"
        typeStyle={TypeStyle.Paragraph}
        color={Colors.Neutral800}
        data-cy="support-card-description"
      >
        Need help to reset your two-factor authentication? Contact us at {JSQ_SUPPORT_EMAIL} or
        call {JSQ_PHONE}
      </Text>
      <Button
        isFullWidth
        className="inline-sm"
        variant="neutral"
        onClick={onGoBackClick}
        data-cy="support-card-go-back-button"
      >
        Back to login
      </Button>
    </LoginCard>
  );
};

export default SupportCard;
